// As paradas de uma carga antes do destino final (entregas fracionadas, 0.19.0),
// dentro do formulário da carga: cidade, UF, o dia em que entregou e uma
// observação. Os campos não têm "name": o formulário da carga não os lê; quem
// salva lê com `ler()` e grava em entregas.salvarDaCarga().
import { h } from '../lib/dom.js';
import { UFS } from '../lib/validacao.js';

const opcoesUf = [['', 'UF'], ...UFS.map((u) => [u, u])];
let contador = 0;

export function editorDeParadas(paradas = [], { desativado = false } = {}) {
  const lista = h('div', { class: 'lista paradas' });

  const linha = (p = {}) => {
    contador += 1;
    const campo = `parada-${contador}`;
    const cidade = h('input', { type: 'text', value: p.cidade ?? '', 'aria-label': 'Cidade da entrega', autocomplete: 'off', disabled: desativado });
    const uf = h('select', { 'aria-label': 'UF da entrega', disabled: desativado },
      opcoesUf.map(([v, t]) => h('option', { value: v, selected: v === (p.uf ?? '') }, t)));
    const dia = h('input', { type: 'date', value: p.data_entrega ?? '', 'aria-label': 'Entregue em', disabled: desativado });
    const obs = h('input', { type: 'text', value: p.observacao ?? '', 'aria-label': 'Observação da entrega', placeholder: 'Observação (opcional)', disabled: desativado });
    const bloco = h('div', { class: 'cartao parada', dataset: { campo, id: p.id ?? '' } },
      h('div', { class: 'cartao-corpo' },
        h('div', { class: 'grade-uf' }, cidade, uf),
        h('label', { class: 'rotulo-pequeno' }, 'Entregue em', dia),
        obs,
        h('p', { class: 'erro-campo', role: 'alert' }),
        !desativado && h('button', { class: 'botao texto', type: 'button', onClick: () => bloco.remove() }, 'Tirar esta entrega')));
    bloco.lerParada = () => ({
      id: bloco.dataset.id || null,
      campo,
      cidade: cidade.value.trim().replace(/\s+/g, ' '),
      uf: uf.value,
      data_entrega: dia.value || null,
      observacao: obs.value.trim() || null,
    });
    return bloco;
  };

  for (const p of paradas) lista.append(linha(p));
  const ler = () => [...lista.children].map((b) => b.lerParada());

  const elemento = h('fieldset', { class: 'campo paradas-da-carga' },
    h('legend', null, 'Entregas antes do destino final'),
    h('p', { class: 'dica' }, 'Quando a carga é entregue em mais de um lugar. O destino final é o de cima; a carga fica entregue nele.'),
    lista,
    !desativado && h('button', {
      class: 'botao secundario',
      type: 'button',
      onClick: () => {
        const nova = linha();
        lista.append(nova);
        nova.querySelector('input').focus();
      },
    }, '+ Entrega no caminho'));

  return {
    elemento,
    ler,
    // Erros por parada, no formato do formulário ({ 'parada-3': 'mensagem' }).
    validar: (dataCarregamento) => {
      const erros = {};
      for (const l of ler()) {
        if (l.cidade.length < 2 || !l.uf) erros[l.campo] = 'Informe a cidade e a UF da entrega (ou toque em "Tirar esta entrega").';
        else if (l.data_entrega && dataCarregamento && l.data_entrega < dataCarregamento) erros[l.campo] = 'A entrega não pode ser antes do carregamento.';
      }
      return erros;
    },
  };
}
